import db from '@/js/services/contracts/Database';
import Dexie from 'dexie';

export default {
  getAll() {
    return db.contracts.where('sync_status').notEqual(2).toArray();
  },
  updateById(id, updateObj) {
    return db.contracts.update(id, Dexie.deepClone(updateObj));
  },
  getById(ids) {
    return db.contracts.where('id').equals(Number.parseInt(ids, 10)).first();
  },
  add(data) {
    return db.contracts.add(Dexie.deepClone(data));
  },
  deleteById(id) {
    return db.contracts.where('id').equals(id).delete();
  },
  getAllSyncPending() {
    return db.contracts.where('sync_status').above(0).with({ field: 'field' });
  },
  async getContractsByFarmer(farmerId) {
    const fields = await db.fields.with('farmer').equals(farmerId).toArray();
    const fieldIds = fields.map((f) => f.id);

    const contracts = await db.contracts.where('field').anyOf(fieldIds).with({ field: 'fields' });
    return contracts;
  },
  getContractsByField(fieldId) {
    return db.contracts.where('field').equals(fieldId).with({ field: 'fields' });
  },

};
